export const ROLE_FETCH_LIST = 'ROLE_FETCH_LIST';
export const ROLE_FETCH_LIST__SUCCESS = 'ROLE_FETCH_LIST__SUCCESS';
export const ROLE_FETCH_LIST__FAILURE = 'ROLE_FETCH_LIST__FAILURE';
export const fetchList = () => ({ type: ROLE_FETCH_LIST });
